<section class="imported-document-page d-flex flex-column">
  <header class="header d-flex align-items-center justify-content-between gap-4 border-bottom">
    <app-page-title
      iconClass="ic-documents-20"
      [header]="pageHeader"
    />

    <div class="controls pr-4 d-flex align-items-center gap-8">
      <!--      <button-->
      <!--        type="button"-->
      <!--        class="btn btn-primary d-flex align-items-center gap-2"-->
      <!--        [disabled]="isLoading()"-->
      <!--      >-->
      <!--        <span>Send email</span>-->
      <!--        <i class="icon ic-arrow-right-20"></i>-->
      <!--      </button>-->
    </div>
  </header>

  <div class="page-content flex-grow-1 d-flex align-items-stretch" [class.sidebar-collapsed]="isSidebarCollapsed()">
    <aside class="sidebar-container">
      <div class="sidebar">
        <div class="p-4 border-bottom">
          @if (company) {
            <div class="mb-4">
              <app-ag-tag-entity-title
                [isLink]="true"
                [entity]="company"
                [entityType]="entityType"
              />
            </div>
          }

          @if (document) {
            <div>
              <ul class="status-elements list-unstyled mb-0">
                <li>
                  <div class="title">Status</div>
                  <div class="value">
                    <app-ag-document-status [status]="document.documentStatus"/>
                  </div>
                </li>

                <li>
                  <div class="title">ASIC Status</div>
                  <div class="value">
                    <app-ag-asic-document-status [status]="document.asicStatus"/>
                  </div>
                </li>

                <li>
                  <div class="title">Date Created</div>
                  <div class="value">{{ document.createdOn | date: 'dd MMM yyyy' }}</div>
                </li>

                <li class="full-width-grid-row">
                  <div class="title">Tags</div>
                  <div class="value">
                    @for (tag of company?.tags; track $index) {
                      <app-tag [tag]="tag"/>
                    } @empty {
                      N/A
                    }
                  </div>
                </li>
              </ul>
            </div>
          } @else if (annualStatement) {
            <div>
              <ul class="status-elements list-unstyled mb-0">
                <li>
                  <div class="title">Status</div>
                  <div class="value">
                    <app-ag-annual-status [status]="annualStatement.annualStatementStatus"/>
                  </div>
                </li>

                <li>
                  <div class="title">Debt</div>
                  <div class="value">
                    {{ annualStatement.company.companyDebt?.amountOwing | currency : "$" : 'code' : '1.2-2'| replaceStr: '-': 'CR ' }}
                  </div>
                </li>

                <li>
                  <div class="title">Signing Status</div>
                  <app-ag-document-signing-status [status]="annualStatement.documentSigning?.signingStatus ?? null"/>
                </li>

                <li>
                  <div class="title">Review Date</div>
                  <div class="value">{{ annualStatement.reviewDate | date: 'dd MMM yyyy' }}</div>
                </li>

                <li>
                  <div class="title">Payment Deadline</div>
                  <div class="value">
                    {{ annualStatement.paymentDeadline ? (annualStatement.paymentDeadline | date : 'dd MMM yyyy') : 'N/A' }}
                  </div>
                </li>

                <li class="full-width-grid-row">
                  <div class="title">Tags</div>
                  <div class="value">
                    @for (tag of company?.tags; track $index) {
                      <app-tag [tag]="tag"/>
                    } @empty {
                      N/A
                    }
                  </div>
                </li>
              </ul>
            </div>
          }
        </div>

        <div class="uploaded-container p-4 d-flex flex-column gap-3">
          <div class="d-flex justify-content-between align-items-center gap-4">
            <div class="title-wrapper d-flex gap-12">
              <div>
                <i class="icon ic-documents-20"></i>
              </div>

              <div class="font-size-16 font-weight-600 line-height-16">Documents</div>
            </div>

            <div
              ngbDropdown
              class="dropdown"
              [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
            >
              <button
                ngbDropdownToggle
                type="button"
                class="btn btn-secondary btn-icon"
              >
                <i class="icon ic-download-20"></i>
              </button>
              <div ngbDropdownMenu class="common-dropdown-menu dropdown-menu dropdown-menu-right">
                <div
                  ngbDropdownItem
                  (click)="downloadCombinedPDF(DocumentSubFolderName.Final)"
                >
                  <span>Download combined PDF</span>
                </div>

                <div
                  ngbDropdownItem
                  (click)="downloadZIP(DocumentSubFolderName.Final)"
                >
                  <span>Download ZIP</span>
                </div>
              </div>
            </div>
          </div>

          <!--  Imported Document Files  -->

          @if (files?.original?.length && document) {
            <div class="original-docs">
              <app-documents-list-accordion
                label="Original"
                noDocsPlaceholder="No original documents"
                [initialClosed]="false"
                [hideDeleteBtn]="true"
                [documents]="files?.original ?? null"
                (downloadFile)="downloadFile($event.name, DocumentSubFolderName.Original)"
              />
            </div>
          }

          @if (files?.attached?.length && document) {
            <div class="uploaded-docs">
              <app-documents-list-accordion
                label="Attached"
                noDocsPlaceholder="No uploaded files"
                [hideDeleteBtn]="true"
                [initialClosed]="!files?.attached?.length"
                [documents]="files?.attached ?? null"
                (downloadFile)="downloadFile($event.name, DocumentSubFolderName.Upload)"
              />
            </div>
          }

          <!--  Imported Annual Statement Files  -->

          @if (files?.final?.length && annualStatement) {
            <div class="uploaded-docs">
              <app-documents-list-accordion
                label="Generated"
                noDocsPlaceholder="No generated documents"
                [hideDeleteBtn]="true"
                [initialClosed]="!files?.final?.length"
                [documents]="files?.final ?? null"
                (downloadFile)="downloadFile($event.name, DocumentSubFolderName.Final)"
              />
            </div>
          }

          @if (files?.signed?.length && annualStatement) {
            <div class="uploaded-docs">
              <app-documents-list-accordion
                label="Signed"
                noDocsPlaceholder="No signed documents"
                [hideDeleteBtn]="true"
                [initialClosed]="!files?.signed?.length"
                [documents]="files?.signed ?? null"
                (downloadFile)="downloadFile($event.name, DocumentSubFolderName.Signed)"
              />
            </div>
          }
        </div>
      </div>
    </aside>

    <div class="content-wrapper position-relative flex-grow-1 border-left" [class.ml-3]="isSidebarCollapsed()">
      <button
        type="button"
        class="btn btn-secondary btn-icon sidebar-switch-btn"
        (click)="isSidebarCollapsed.set(!isSidebarCollapsed())"
      >
        <i
          class="icon"
          [class]="{
            'ic-arrow-left-20': !isSidebarCollapsed(),
            'ic-arrow-right-20': isSidebarCollapsed()
          }"
        ></i>
      </button>

      <div class="content">
        @if (isLoading()) {
          <app-loader/>
        } @else {
          <div class="p-4 d-flex flex-column gap-12">
            <h3 class="font-size-18 line-height-24 m-0">Imported Documents Notice</h3>

            <app-disclaimer icon="ic-alert-triangle-20">
              The documents listed on this page were imported from your previous corporate compliance system. As a
              result,
              the option to send these documents via Pravo is currently unavailable.
            </app-disclaimer>
          </div>
        }
      </div>
    </div>
  </div>
</section>
